import type { QueryKey } from '@tanstack/react-query';

// eslint-disable-next-line unicorn/prefer-structured-clone, @typescript-eslint/no-unsafe-type-assertion -- We actually do not want perform deep clone with structured clone, TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
export const generateQueryKey = <T extends QueryKey = QueryKey>(data: T) => JSON.parse(JSON.stringify(data)) as T;
